import React, {useState} from 'react';
import WorkableIconCalcButton from "../../button/WorkableIconCalcButton";
import PropTypes from "prop-types";
import NetGrossCalcPopup from "./NetGrossCalcPopup";
import Tr from "../../../translations/Translations";


const NetGrossCalc = (
    {
        disabled,
        netValue,
        setNetValue,
        grossValue,
        setGrossValue
    }
) => {
    const [calcOpen, setCalcOpen] = useState(false);

    const noValues = !netValue && !grossValue;

    return (
        <>
            <NetGrossCalcPopup
                open={calcOpen}
                onClose={() => setCalcOpen(false)}
                disabled={noValues || disabled}
                netValue={netValue}
                setNetValue={setNetValue}
                grossValue={grossValue}
                setGrossValue={setGrossValue}
            />
            <WorkableIconCalcButton tooltip={noValues ? Tr('calc_no_values') : undefined} disabled={noValues || disabled} onClick={() => setCalcOpen(true)}/>
        </>
    );
};


NetGrossCalc.propTypes = {
    disabled: PropTypes.bool,
    tooltip: PropTypes.string
}

export default NetGrossCalc;